export const en = {
  nav: {
    home: 'Home',
    services: 'Services',
    about: 'About',
    gallery: 'Gallery',
    contact: 'Contact',
    faq: 'FAQ',
    signIn: 'Sign In',
    signOut: 'Sign Out',
    myAccount: 'My Account',
    admin: 'Admin',
    bookNow: 'Book Now',
    privacy: 'Privacy',
    terms: 'Terms'
  },
  
  business: {
    name: 'Mécanique Auto CJPA',
    tagline: 'Premium Automotive Service',
    address: '10011 Av. de Rome, Montréal-Nord, QC H1H 4N3, Canada',
    phone: '+1 514-327-2107',
    phone2: '+1 514-582-7527',
    email: 'info@mecanique-cjpa.com',
    hours: {
      title: 'Business Hours',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      weekdaysTime: '9:00 AM – 6:00 PM',
      saturdayTime: 'Closed',
      sundayTime: 'Closed',
      closed: 'Closed'
    }
  },
  
  home: {
    hero: {
      subtitle: 'Premium Automotive Service',
      title: 'Mécanique Auto CJPA',
      description: 'Where precision meets passion. Exceptional care for exceptional vehicles.',
      bookButton: 'Book an Appointment',
      servicesButton: 'Our Services'
    },
    stats: {
      years: '15+',
      yearsLabel: 'Years Experience',
      vehicles: '8,000+',
      vehiclesLabel: 'Vehicles Serviced',
      satisfaction: '98%',
      satisfactionLabel: 'Client Satisfaction',
      technicians: '12',
      techniciansLabel: 'Expert Technicians'
    },
    services: {
      subtitle: 'What We Offer',
      title: 'Our',
      titleHighlight: 'Services',
      viewAll: 'View All Services →',
      from: 'From',
      min: 'min'
    },
    whyChoose: {
      subtitle: 'The CJPA Standard',
      title: 'Precision.',
      titleHighlight: 'Excellence.',
      titleEnd: 'Trust.',
      description: 'At Mécanique Auto CJPA, we believe your vehicle deserves the same meticulous attention to detail that goes into crafting it. Our certified technicians bring decades of expertise to every service, using only premium-grade parts and the latest diagnostic technology.',
      button: 'Schedule Service',
      certified: {
        title: 'Certified Excellence',
        desc: 'ASE-certified technicians with manufacturer-specific training for all major makes and models.'
      },
      pricing: {
        title: 'Transparent Pricing',
        desc: 'No surprises. Detailed estimates provided before any work begins, with your full approval required.'
      },
      parts: {
        title: 'Genuine Parts',
        desc: 'OEM and premium aftermarket parts, backed by comprehensive warranties for your peace of mind.'
      },
      inspection: {
        title: 'Complimentary Inspection',
        desc: 'Every service includes a thorough multi-point vehicle inspection report at no additional charge.'
      }
    },
    reviews: {
      subtitle: 'What Our Clients Say',
      title: 'Customer',
      titleHighlight: 'Reviews',
      rating: '4.9 Google Rating',
      viewAll: 'View All Google Reviews',
      reviews: 'reviews'
    },
    cta: {
      subtitle: 'Ready to Begin?',
      title: 'Book Your',
      titleHighlight: 'Appointment',
      description: 'Experience automotive service at its finest. Our team is ready to care for your vehicle with the attention it deserves.',
      button: 'Reserve Your Time'
    }
  },

  services: {
    title: 'Our',
    titleHighlight: 'Services',
    subtitle: 'Expert Care',
    description: 'From routine maintenance to complex repairs, every service is performed with meticulous precision by our certified technicians.',
    allCategory: 'All',
    bookButton: 'Book',
    callForPricing: 'Call for pricing',
    estimated: 'Estimated',
    minutes: 'minutes',
    dontSee: "Don't see the service you need? Contact us — we handle a wide range of automotive repairs and maintenance.",
    scheduleButton: 'Schedule Your Service',
    from: 'From'
  },

  booking: {
    title: 'Book an',
    titleHighlight: 'Appointment',
    subtitle: 'Reserve Your Visit',
    steps: {
      service: 'Service',
      schedule: 'Schedule',
      vehicle: 'Vehicle',
      review: 'Review'
    },
    selectService: 'Select Services',
    selectMultipleHint: 'Select one or more services for your appointment',
    servicesSelected: 'service(s) selected',
    totalDuration: 'Duration',
    totalPrice: 'Price',
    totalLabel: 'Total',
    maxServices: 'Maximum 6 services per appointment',
    chooseDatetime: 'Choose Date & Time',
    yourVehicle: 'Your Vehicle',
    reviewConfirm: 'Review & Confirm',
    
    dateLabel: 'Preferred Date',
    timeLabel: 'Available Times',
    notesLabel: 'Additional Notes (Optional)',
    notesPlaceholder: 'Describe any issues or special requests...',
    
    useSaved: 'Use Saved Vehicle',
    addNew: 'Add New Vehicle',
    selectVehicle: 'Select Vehicle',
    addDifferent: '+ Add Different Vehicle',
    
    makeLabel: 'Make',
    makePlaceholder: 'Select Make',
    modelLabel: 'Model',
    modelPlaceholder: 'Select Model',
    specifyModel: 'Specify Model',
    specifyPlaceholder: 'Enter your vehicle model',
    yearLabel: 'Year',
    plateLabel: 'License Plate (Optional)',
    platePlaceholder: 'ABC-1234',
    searchMake: 'Search make...',
    searchModel: 'Search model...',
    otherMake: 'Other (not listed)',
    otherModel: 'Other (not listed)',
    popularMakes: 'Popular Makes',
    allMakes: 'All Makes',
    noMakesFound: 'No makes found',
    noModelsFound: 'No models found',
    backToSearch: 'Back to search',
    
    reviewLabels: {
      service: 'Service',
      datetime: 'Date & Time',
      vehicle: 'Vehicle',
      client: 'Client',
      notes: 'Notes'
    },
    
    continueButton: 'Continue →',
    backButton: '← Back',
    confirmButton: 'Confirm Appointment',
    bookingButton: 'Booking...',
    bookingError: 'Booking failed. Please try again.',
    noAvailableTimes: 'No available times for this date. Please select another date.',
    loadingTimes: 'Loading available times...',
    closedDayError: 'This day is closed. Please select another date.',
    pastDateError: 'You cannot select a past date. Please choose today or a future date.',
    depositRequired: 'A deposit is required to confirm this appointment.',
    depositAmount: 'Deposit Amount',
    proceedToPayment: 'Proceed to Payment',
    paymentProcessing: 'Processing...',
    paymentSuccess: 'Payment successful! Your appointment is confirmed.',
    paymentCancelled: 'Payment cancelled. You can try again or contact the shop.',
    paymentPending: 'Payment Pending',
    at: 'at',

    success: {
      confirmed: 'Confirmed',
      title: 'Appointment Booked',
      message: "Your appointment has been received. We'll confirm shortly and send you a reminder. Thank you for choosing Mécanique Auto CJPA.",
      viewButton: 'View My Appointments',
      depositPaid: 'Deposit Paid'
    }
  },

  dashboard: {
    welcome: 'Welcome Back',
    newAppt: '+ New Appointment',
    upcoming: 'Upcoming',
    completed: 'Completed',
    total: 'Total',
    tabs: {
      upcoming: 'Upcoming',
      completed: 'Completed',
      past: 'Past',
      cancelled: 'Cancelled'
    },
    yourReview: 'Your Review',
    noAppts: 'No appointments found',
    firstAppt: 'Book your first appointment →',
    cancel: 'Cancel',
    reschedule: 'Reschedule',
    rescheduleTitle: 'Reschedule Appointment',
    rescheduleConfirm: 'Confirm New Time',
    rescheduleSuccess: 'Appointment rescheduled successfully',
    cancelConfirm: 'Are you sure you want to cancel this appointment?',
    cancelSuccess: 'Appointment cancelled successfully',
    cutoffError: 'Cannot modify within {hours} hours of the appointment',
    leaveReview: 'Leave Review',
    reviewed: 'Reviewed',
    confirmCancel: 'Are you sure you want to cancel this appointment?',
    cancelError: 'Error cancelling appointment',
    at: 'at',
    status: {
      pending: 'Pending',
      confirmed: 'Confirmed',
      in_progress: 'In Progress',
      completed: 'Completed',
      cancelled: 'Cancelled'
    },
    account: {
      title: 'Account Information',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      notProvided: 'Not provided'
    },
    notifications: {
      title: 'Notification Preferences',
      emailToggle: 'Email notifications',
      smsToggle: 'SMS notifications',
      smsVerifyHint: 'Verify your phone number to enable SMS notifications',
      preferredLang: 'Preferred language for notifications',
      save: 'Save Preferences',
      saving: 'Saving...',
      saved: 'Preferences saved successfully',
      error: 'Failed to save preferences',
      pushToggle: 'Push notifications',
      pushDenied: 'Push blocked — enable in browser settings',
      marketingToggle: 'Marketing emails',
      marketingHint: 'Receive promotions and news from us'
    },
    calendar: {
      addToCalendar: 'Add to Calendar'
    },
    messages: {
      title: 'My Messages',
      empty: 'No messages',
      viewThread: 'View Thread',
      hideThread: 'Hide Thread',
      replyPlaceholder: 'Type your reply...',
      sendReply: 'Send Reply',
      sending: 'Sending...',
      replyFailed: 'Failed to send reply',
      status: {
        new: 'New',
        read: 'Read',
        responded: 'Responded'
      },
      attachImages: 'Attach Images',
      attachHint: 'Max 3 images, 5MB each'
    },
    sections: {
      appointments: 'Appointments',
      messages: 'Messages',
      profile: 'Profile',
      settings: 'Settings'
    },
    profile: {
      title: 'Profile Information',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email Address',
      phone: 'Phone Number',
      phoneVerified: 'Phone verified',
      verifyPhone: 'Verify Phone',
      save: 'Save Profile',
      saving: 'Saving...',
      saved: 'Profile updated successfully',
      error: 'Failed to update profile',
      emailInUse: 'This email is already in use',
      phone2: 'Secondary Phone',
      phone2Hint: 'Optional \u2014 verify to receive SMS on this number too'
    },
    phoneBanner: {
      title: 'Verify Your Phone Number',
      message: 'Add and verify your phone number to receive SMS reminders for your appointments.',
      verify: 'Verify Now',
      dismiss: 'Not Now',
      reminderSmall: 'Your phone number is not verified.',
      verifyLink: 'Verify now'
    },
    pushBanner: {
      title: 'Enable Push Notifications',
      message: 'Get instant notifications about appointment updates, promotions, and important reminders directly on your device.',
      enable: 'Enable Now',
      dismiss: 'Not Now'
    },
    reviewModal: {
      title: 'How was your service?',
      rating: 'Rating',
      comment: 'Your Review (Optional)',
      placeholder: 'Share your experience with us...',
      submit: 'Submit Review',
      submitting: 'Submitting...',
      cancel: 'Cancel',
      success: 'Thank you for your review!',
      error: 'Could not submit review. Please try again.',
      googleReview: 'Also leave a Google Review',
      done: 'Done'
    }
  },

  auth: {
    login: {
      title: 'Welcome Back',
      subtitle: 'Sign in to manage your appointments',
      emailLabel: 'Email Address',
      passwordLabel: 'Password',
      button: 'Sign In',
      signing: 'Signing In...',
      noAccount: 'New client?',
      register: 'Create an account →',
      invalidCredentials: 'Invalid credentials',
      forgotPassword: 'Forgot password?'
    },
    register: {
      title: 'Create Your Account',
      subtitle: 'Join our exclusive clientele',
      firstNameLabel: 'First Name',
      lastNameLabel: 'Last Name',
      emailLabel: 'Email Address',
      confirmEmailLabel: 'Confirm Email',
      phoneLabel: 'Phone Number',
      passwordLabel: 'Password',
      confirmLabel: 'Confirm Password',
      button: 'Create Account',
      creating: 'Creating Account...',
      hasAccount: 'Already a client?',
      signIn: 'Sign in →',
      emailMismatch: 'Email addresses do not match',
      passwordMismatch: 'Passwords do not match',
      passwordTooShort: 'Password must be at least 6 characters',
      registrationFailed: 'Registration failed',
      invalidEmail: 'Please enter a valid email address',
      invalidPhone: 'Please enter a valid phone number',
      nameTooLong: 'Name must be 50 characters or less',
      consent: {
        transactionalTitle: 'Service emails (required)',
        transactionalDesc: "We'll email you about appointments, confirmations, updates, and account security.",
        marketingLabel: 'I agree to receive offers, promotions, and tips by email from Mécanique Auto CJPA. I can unsubscribe at any time.',
        marketingHint: 'Marketing consent is optional and does not affect your service.',
        privacyLink: 'Privacy Policy'
      }
    }
  },

  about: {
    title: 'About',
    titleHighlight: 'Us',
    subtitle: 'Our Story',
    mission: {
      title: 'Our Mission',
      text: 'At Mécanique Auto CJPA, we are committed to providing exceptional automotive service with integrity, expertise, and dedication. Since our establishment, we have built a reputation for quality workmanship and customer satisfaction in the Montréal-Nord community.'
    },
    history: {
      title: 'Our Story',
      paragraphs: [
        'Our story began on March 31, 2016, driven by a shared vision and mutual trust. At the time, we were both working in the same automotive repair shop when the idea of opening our own garage became an obvious next step.',
        'We wanted to build a shop that reflected our values: integrity, precision, and a strong commitment to quality service. A place where customers would always be treated with honesty, transparency, and professionalism.',
        'The very next day, we began searching for a location. Just two days later, the lease was signed. At that point, we owned little more than two toolboxes and a floor jack — but what we truly had was far more important: experience, determination, and the drive to succeed.',
        'Exactly one week later, on April 4, 2016, our garage officially opened its doors.',
        'What started as a simple conversation has grown into a business built on a passion for the trade, attention to detail, and the trust of our customers. Today, we are proud of how far we\'ve come and deeply grateful to everyone who allows us to continue growing and improving every single day.'
      ]
    },
    team: {
      title: 'Our Team',
      text: 'Our team of ASE-certified technicians brings decades of combined experience in automotive repair and maintenance. We continuously invest in training and the latest diagnostic equipment to ensure we can service all makes and models with precision and care.'
    },
    values: {
      title: 'Our Values',
      quality: 'Quality',
      qualityText: 'We never compromise on the quality of our work or the parts we use. Your safety and satisfaction are our top priorities.',
      transparency: 'Transparency',
      transparencyText: 'Clear communication and honest pricing with every service. We explain what needs to be done and why.',
      expertise: 'Expertise',
      expertiseText: 'Continuous training to stay current with evolving automotive technology and manufacturer specifications.',
      community: 'Community',
      communityText: 'Proud to serve the Montréal-Nord community with excellence. We treat every customer like family.'
    },
    visit: 'Visit Us Today',
    visitText: 'Experience the CJPA difference. Our facility is equipped with state-of-the-art diagnostic tools and our team is ready to exceed your expectations.'
  },

  contact: {
    title: 'Contact',
    titleHighlight: 'Us',
    subtitle: 'Get in Touch',
    visitUs: 'Visit Us',
    callUs: 'Call Us',
    emailUs: 'Email Us',
    directions: 'Get Directions',
    form: {
      title: 'Send us a Message',
      nameLabel: 'Your Name',
      emailLabel: 'Your Email',
      phoneLabel: 'Phone Number',
      subjectLabel: 'Subject',
      messageLabel: 'Message',
      messagePlaceholder: 'How can we help you?',
      send: 'Send Message',
      sending: 'Sending...',
      success: "Message sent! We'll get back to you soon.",
      error: 'Could not send message. Please try again or call us directly.',
      loginRequired: 'Please sign in to send us a message.',
      loginButton: 'Sign In',
      messageTooShort: 'Message must be at least 5 characters',
      messageTooLong: 'Message must be 2000 characters or less',
      subjectTooLong: 'Subject must be 200 characters or less',
      charCount: 'characters',
      attachImages: 'Attach Images',
      attachHint: 'Max 3 images, 5MB each (JPEG, PNG, GIF, WebP)'
    }
  },

  faq: {
    title: 'Frequently Asked',
    titleHighlight: 'Questions',
    subtitle: 'Common Questions',
    categories: {
      services: 'Services',
      booking: 'Booking',
      pricing: 'Pricing',
      general: 'General'
    }
  },

  gallery: {
    title: 'Our',
    titleHighlight: 'Work',
    subtitle: 'Gallery',
    description: 'Take a look at some of the quality work we perform every day. From routine maintenance to complex repairs, we take pride in every job.',
    images: [
      { title: 'Engine Repair', desc: 'Complex engine diagnostic and repair', src: '/images/gallery/engine-repair.jpg', altKey: 'gallery1' },
      { title: 'Brake Service', desc: 'Professional brake pad replacement', src: '/images/gallery/brake-service.jpg', altKey: 'gallery2' },
      { title: 'Oil Change', desc: 'Quick and efficient oil change service', src: '/images/gallery/oil-change.jpg', altKey: 'gallery3' },
      { title: 'Diagnostic Work', desc: 'Advanced computer diagnostic systems', src: '/images/gallery/diagnostic-scan.jpg', altKey: 'gallery4' },
      { title: 'Transmission Service', desc: 'Expert transmission maintenance', src: '/images/gallery/transmission-repair.jpg', altKey: 'gallery5' },
      { title: 'Wheel Alignment', desc: 'Precision wheel alignment service', src: '/images/gallery/wheel-alignment.jpg', altKey: 'gallery6' }
    ],
    comingSoon: 'Photos coming soon! Follow us on social media to see our latest work.'
  },

  privacy: {
    title: 'Privacy',
    titleHighlight: 'Policy',
    lastUpdated: 'Last Updated: February 2026',
    intro: 'At Mécanique Auto CJPA, we respect your privacy and are committed to protecting your personal information in accordance with the Personal Information Protection and Electronic Documents Act (PIPEDA) and Quebec\'s Act respecting the protection of personal information in the private sector (Law 25). This policy explains how we collect, use, store, and safeguard your data.',
    sections: [
      ['Privacy Officer', 'In compliance with Quebec\'s Law 25, Mécanique Auto CJPA has designated a Privacy Officer responsible for the protection of personal information. For any questions, requests, or concerns regarding your personal data, you may contact our Privacy Officer at: info@mecanique-cjpa.com or by phone at +1 514-327-2107 / +1 514-582-7527, or by mail at 10011 Av. de Rome, Montréal-Nord, QC H1H 4N3, Canada.'],
      ['Applicable Laws', 'This privacy policy is governed by Quebec\'s Act respecting the protection of personal information in the private sector (Law 25), as amended, and the Personal Information Protection and Electronic Documents Act (PIPEDA) for any inter-provincial or international activities. We are committed to complying with all applicable Canadian and Quebec privacy laws and regulations.'],
      ['Information We Collect', 'We collect the following personal information when you use our website, book an appointment, or create an account: your first and last name, email address, phone number, vehicle information (make, model, year, license plate), appointment details and service history, account credentials (encrypted password), contact form messages, and language preferences. This information is collected directly from you when you voluntarily provide it through our website forms.'],
      ['Purposes of Collection', 'We collect and use your personal information for the following specific purposes: processing and managing your appointment bookings; providing automotive repair and maintenance services; communicating with you about your appointments, services, and vehicle status; maintaining your service and vehicle history for future visits; responding to your inquiries submitted through our contact form; managing your online account; remembering your language preference (English/French); improving our website and services; and complying with legal and regulatory obligations. We will not use your personal information for any purpose other than those stated above without first obtaining your consent.'],
      ['Consent', 'By creating an account, booking an appointment, or submitting a contact form on our website, you provide your express consent to the collection, use, and storage of your personal information for the purposes described in this policy. Your consent is voluntary. You may withdraw your consent at any time by contacting our Privacy Officer. Please note that withdrawing consent may affect our ability to provide certain services, such as managing your appointments or maintaining your service history. We do not use pre-checked consent boxes and will always clearly inform you of what data is being collected and why.'],
      ['Data Storage and Security', 'Your personal information is stored in encrypted databases hosted in Canada. We implement industry-standard security measures to protect your data, including: encryption of data in transit and at rest, secure password hashing (bcrypt), access controls limiting data access to authorized personnel only, regular security reviews of our systems, and secure session management. Despite our best efforts, no method of electronic storage is 100% secure. We take all reasonable precautions to protect your information but cannot guarantee absolute security.'],
      ['Data Retention', 'We retain your personal information only for as long as necessary to fulfill the purposes for which it was collected: active account data is retained for the duration of your account plus 3 years after your last activity; appointment and service records are retained for 7 years for warranty and legal purposes; contact form messages are retained for 2 years; session cookies expire when you close your browser; language preference cookies are retained until you clear your browser data. When personal information is no longer needed, it is securely deleted or anonymized.'],
      ['Cookies and Tracking Technologies', 'Our website uses only essential cookies necessary for the operation of the site: session cookies to maintain your login state, and a language preference cookie to remember your choice of English or French. We do not use any tracking cookies, analytics cookies, advertising cookies, or any third-party tracking technologies. No profiling or behavioural tracking is performed. You may configure your browser to refuse cookies, but this may affect the functionality of certain features such as staying logged in.'],
      ['Third-Party Service Providers', 'We may share limited personal information with trusted third-party service providers who assist us in operating our business, such as web hosting providers and email service providers. These providers are contractually obligated to protect your personal information and may only use it for the specific services we have engaged them to provide. Your personal information is not sold, rented, or traded to any third parties for marketing or any other purposes. All service providers used are based in Canada or are bound by equivalent privacy protections.'],
      ['Cross-Border Data Transfers', 'Your personal information is primarily stored and processed in Canada. In the event that personal information needs to be transferred outside of Quebec or Canada, we will ensure that adequate protection measures are in place in compliance with Law 25, and we will inform you and obtain your consent before any such transfer takes place.'],
      ['Your Rights Under Canadian and Quebec Law', 'Under PIPEDA and Quebec\'s Law 25, you have the following rights regarding your personal information: the right to be informed about how your personal information is collected, used, and disclosed; the right to access your personal information held by us; the right to request correction of inaccurate or incomplete information; the right to request deletion or anonymization of your personal information; the right to data portability — to receive your information in a structured, commonly used format and to have it transferred to another organization; the right to withdraw your consent at any time; and the right to file a complaint if you believe your privacy rights have been violated. To exercise any of these rights, please contact our Privacy Officer. We will respond to your request within 30 days.'],
      ['Data Breach Notification', 'In the event of a security breach involving your personal information that presents a risk of serious injury, we will: notify the Commission d\'accès à l\'information du Québec (CAI) as required by Law 25; notify you as soon as possible, describing the nature of the breach, the information involved, and the measures we are taking; and maintain a record of all security incidents. We maintain procedures to detect, investigate, and respond to data breaches promptly.'],
      ['Children\'s Privacy', 'Our services are not directed at children under the age of 14. We do not knowingly collect personal information from children under 14. For minors aged 14 to 17, consent may be provided by the minor themselves in accordance with Quebec law. If we become aware that we have collected information from a child under 14 without parental consent, we will take steps to delete that information promptly.'],
      ['Automated Decision-Making', 'We do not use automated decision-making or profiling systems that produce legal effects or similarly significant effects on individuals. All decisions regarding your services and appointments are made by our team members.'],
      ['Changes to This Policy', 'We may update this privacy policy from time to time to reflect changes in our practices, technology, or legal requirements. Any material changes will be posted on this page with an updated effective date. We encourage you to review this policy periodically. Continued use of our services after changes are posted constitutes acceptance of the updated policy.'],
      ['Filing a Complaint', 'If you believe that your privacy rights have been violated, you may file a complaint with our Privacy Officer at info@mecanique-cjpa.com. If you are not satisfied with our response, you have the right to file a complaint with: the Commission d\'accès à l\'information du Québec (CAI) — www.cai.gouv.qc.ca — the primary regulatory authority for Quebec privacy matters; or the Office of the Privacy Commissioner of Canada (OPC) — www.priv.gc.ca — for matters under PIPEDA.'],
      ['Contact Us', 'For any questions, concerns, or requests regarding this privacy policy or the handling of your personal information, please contact us at: Mécanique Auto CJPA, Attn: Privacy Officer, 10011 Av. de Rome, Montréal-Nord, QC H1H 4N3, Canada. Email: info@mecanique-cjpa.com. Phone: +1 514-327-2107 / +1 514-582-7527.']
    ]
  },

  terms: {
    title: 'Terms of',
    titleHighlight: 'Service',
    lastUpdated: 'Last Updated: February 2026',
    intro: 'These Terms of Service govern your use of the Mécanique Auto CJPA website and our automotive repair and maintenance services. By using our website, booking an appointment, or creating an account, you agree to these terms. These terms are subject to the Quebec Consumer Protection Act, the Civil Code of Quebec, and all applicable Canadian and Quebec laws. In the event of a conflict between the French and English versions of these terms, the French version shall prevail as required by Quebec law.',
    sections: [
      ['Merchant Information', 'Mécanique Auto CJPA, located at 10011 Av. de Rome, Montréal-Nord, QC H1H 4N3, Canada. Phone: +1 514-327-2107 / +1 514-582-7527. Email: info@mecanique-cjpa.com. Privacy Officer: info@mecanique-cjpa.com.'],
      ['Services', 'We provide professional automotive repair and maintenance services, including but not limited to oil changes, brake service, engine diagnostics, transmission service, wheel alignment, tire rotation, battery replacement, suspension and steering service, and air conditioning service. All services are performed by ASE-certified technicians using quality parts and equipment, in accordance with industry standards and manufacturer specifications.'],
      ['Online Appointments', 'Appointments may be booked through our website and are subject to availability. By booking an appointment, you are requesting a service — final confirmation will be provided by our team. We reserve the right to reschedule appointments if necessary due to unforeseen circumstances and will notify you as soon as possible. Cancellations should be made at least 24 hours in advance. No cancellation fees are charged.'],
      ['Estimates and Pricing', 'In accordance with the Quebec Consumer Protection Act, a written estimate will be provided for any repair expected to exceed $100. We will not proceed with any work that exceeds the estimate by more than 10% without your prior authorization. If a fee is charged for providing an estimate, you will be informed of this fee before the estimate is prepared. All prices displayed on our website are in Canadian dollars (CAD) and include applicable information about price ranges. Final pricing is determined after vehicle inspection and is communicated to you for approval before any work begins. We honour all advertised prices in compliance with the Canadian Competition Act.'],
      ['Payment', 'Payment is due upon completion of services. We accept cash, all major credit cards, and debit cards. All prices are in Canadian dollars. A detailed invoice will be provided for every service, including: the date of vehicle delivery, odometer reading, description of work performed, name and condition of each part installed (new, used, or remanufactured), individual price of each part, number of hours of labour billed, hourly rate, and total cost.'],
      ['Warranty on Repairs', 'In compliance with the Quebec Consumer Protection Act, all repairs exceeding $50 are guaranteed for a minimum of 3 months or 5,000 kilometres, whichever comes first. This warranty covers both parts and labour related to the original repair. If your vehicle must return to our shop for the same issue during the warranty period, the warranty period is extended by the number of days your vehicle is in our possession for the warranty repair. The warranty does not cover damage resulting from misuse, negligence, accidents, normal wear and tear, or modifications performed by third parties. To make a warranty claim, contact us with your original invoice and a description of the issue.'],
      ['Replaced Parts', 'In accordance with Quebec law, you have the right to request the return of any parts that have been replaced during a repair. Please make this request at the time of service. If no request is made, replaced parts may be disposed of in accordance with environmental regulations.'],
      ['Customer Obligations', 'As a customer, you agree to: provide accurate and complete information about your vehicle (make, model, year, known issues); disclose any pre-existing conditions or modifications that may affect the service; arrive at your scheduled appointment time or notify us of delays; provide timely authorization for any work that exceeds the original estimate; and pick up your vehicle within a reasonable time after service completion.'],
      ['Our Obligations', 'We are committed to: performing all services with prudence, diligence, and in accordance with industry standards and the rules of our trade as required by the Civil Code of Quebec; using quality parts appropriate for your vehicle; providing honest and transparent communication about required repairs; providing a detailed invoice for all work performed; and standing behind our work with the warranty described in these terms.'],
      ['Limitation of Liability', 'In accordance with Quebec law, nothing in these terms limits or excludes our liability for: intentional or gross fault on our part or that of our employees; bodily injury; or any liability that cannot be excluded or limited under the Quebec Consumer Protection Act or the Civil Code of Quebec. We are not liable for pre-existing vehicle conditions not related to the services we performed, damage caused by the customer\'s failure to disclose known issues, normal wear and tear, or issues arising from unauthorized modifications to work we have performed. Any limitation of liability in these terms is subject to and does not override your rights under the Quebec Consumer Protection Act and the Civil Code of Quebec.'],
      ['Vehicle Storage', 'While your vehicle is in our care for service, we maintain appropriate insurance coverage and take reasonable precautions to protect it. Vehicles should be picked up within 48 hours of service completion unless otherwise arranged. We are not responsible for personal items left in the vehicle. Vehicles left for an extended period without communication may be subject to storage fees after reasonable notice has been provided.'],
      ['User Accounts', 'When creating an account on our website, you agree to provide accurate information and maintain the confidentiality of your login credentials. You are responsible for all activity under your account. You may request the deletion of your account at any time by contacting us. Account data is handled in accordance with our Privacy Policy and Quebec\'s Law 25.'],
      ['Intellectual Property', 'All content on our website, including text, design, logos, and images, is the property of Mécanique Auto CJPA and is protected by Canadian copyright law. You may not reproduce, distribute, or use our content without written permission. User-generated content such as reviews remains your property, but you grant us a non-exclusive license to display it on our website.'],
      ['Privacy and Data Protection', 'Your personal information is collected, used, and protected in accordance with our Privacy Policy, Quebec\'s Law 25, and the Personal Information Protection and Electronic Documents Act (PIPEDA). By using our services, you consent to the collection and use of your personal information as described in our Privacy Policy. You have the right to access, correct, delete, and port your personal information as detailed in our Privacy Policy.'],
      ['Dispute Resolution', 'We are committed to resolving any disputes fairly and promptly. If you have a complaint, please contact us directly at info@mecanique-cjpa.com or +1 514-327-2107 / +1 514-582-7527. In accordance with the Quebec Consumer Protection Act, these terms do not contain any mandatory arbitration clause, and your right to bring legal proceedings before the courts is fully preserved. You also retain the right to participate in any class action. If we are unable to resolve your complaint, you may file a complaint with the Office de la protection du consommateur (OPC) at www.opc.gouv.qc.ca or call 1-888-OPC-ALLO (672-2556).'],
      ['Language', 'In compliance with Quebec\'s Charter of the French Language, these Terms of Service are available in both French and English. The French version is the official version. In the event of any discrepancy between the French and English versions, the French version shall prevail.'],
      ['Governing Law', 'These terms are governed by and construed in accordance with the laws of the Province of Quebec and the applicable laws of Canada. Any dispute arising from these terms shall be subject to the exclusive jurisdiction of the courts of Quebec. Nothing in these terms limits your rights under the Quebec Consumer Protection Act, the Civil Code of Quebec, or any other applicable legislation.'],
      ['Consumer Rights', 'These Terms of Service are subject to and do not override your rights under the Quebec Consumer Protection Act, the Civil Code of Quebec, and all other applicable consumer protection legislation. You are encouraged to familiarize yourself with your rights as a consumer. For more information, visit the Office de la protection du consommateur at www.opc.gouv.qc.ca.'],
      ['Changes to Terms', 'We may update these Terms of Service from time to time to reflect changes in our practices or legal requirements. Material changes will be posted on this page with an updated effective date. We encourage you to review these terms periodically. Continued use of our services after changes are posted constitutes your acceptance of the updated terms, subject to your rights under applicable law.'],
      ['Contact Us', 'For any questions, concerns, or complaints regarding these Terms of Service, please contact us at: Mécanique Auto CJPA, 10011 Av. de Rome, Montréal-Nord, QC H1H 4N3, Canada. Email: info@mecanique-cjpa.com. Phone: +1 514-327-2107 / +1 514-582-7527.']
    ]
  },

  footer: {
    description: 'Premium automotive service delivered with precision, expertise, and an unwavering commitment to excellence.',
    navigate: 'Navigate',
    services: 'Services',
    servicesList: ['Oil Change', 'Brake Service', 'Engine Diagnostic', 'Wheel Alignment', 'Transmission'],
    excellence: 'Excellence in Every Detail',
    rights: '© 2024 Mécanique Auto CJPA. All rights reserved.'
  },

  admin: {
    title: 'Admin',
    titleHighlight: 'Dashboard',
    welcome: 'Welcome back',
    stats: {
      todayAppts: "Today's Appointments",
      pending: 'Pending',
      totalCustomers: 'Total Customers',
      avgRating: 'Avg Rating',
      reviews: 'reviews'
    },
    tabs: {
      overview: 'Overview',
      appointments: 'Appointments',
      reviews: 'Reviews',
      messages: 'Messages',
      customers: 'Customers',
      settings: 'Settings',
      services: 'Services',
      promotions: 'Promotions',
      campaigns: 'Campaigns',
      reminders: 'Reminders',
      reports: 'Reports',
      import: 'Import',
      marketing: 'Marketing Copy'
    },
    reports: {
      // Filter controls
      startDate: 'Start Date',
      endDate: 'End Date',
      applyFilter: 'Apply',
      clearFilter: 'Clear',
      filterFormLabel: 'Report date range filter',
      presetToday: 'Today',
      preset7d: 'Last 7 days',
      presetMonth: 'This month',
      presetLastMonth: 'Last month',
      presetQuarter: 'This quarter',
      presetYtd: 'YTD',
      presetAll: 'All time',
      // Summary KPIs
      summaryTitle: 'Revenue Report',
      completedAppointments: 'Completed',
      confirmedRevenue: 'Confirmed Revenue',
      netRevenue: 'Net Revenue',
      depositsCollected: 'Deposits Collected',
      deposits: 'deposits',
      refundsIssued: 'Refunds Issued',
      estimatedLow: 'Est. Low',
      estimatedHigh: 'Est. High',
      estimatedMid: 'Est. Midpoint',
      avgTicketConfirmed: 'Avg Ticket',
      completionRate: 'Completion Rate',
      cancellationRate: 'Cancellation Rate',
      avgLeadDays: 'Avg Lead Time',
      days: 'days',
      repeatRate: 'Repeat Rate',
      customers: 'customers',
      zeroBanner: 'No confirmed revenue yet. Record actual prices when completing appointments to see exact figures here.',
      // Charts
      revenueOverTime: 'Revenue Over Time',
      topServices: 'Top 5 Services by Revenue',
      statusDistribution: 'Appointment Status Distribution',
      // By service table
      byService: 'Revenue by Service',
      byServiceCaption: 'Revenue breakdown by service type',
      service: 'Service',
      lineItems: 'Services',
      appointments: 'Appts',
      confirmed: 'Confirmed',
      avgPrice: 'Avg Price',
      pctOfTotal: '% of Total',
      sortBy: 'Sort',
      sort_revenue: 'Revenue',
      sort_count: 'Count',
      sort_name: 'Name',
      // By month table
      byMonth: 'Revenue by Month',
      byMonthCaption: 'Monthly revenue breakdown',
      month: 'Month',
      vsPrior: 'vs Prior',
      total: 'Total',
      // Upcoming
      upcomingRevenue: 'Upcoming Estimated Revenue',
      upcomingAppointments: 'Upcoming',
      upcomingByServiceCaption: 'Upcoming revenue by service',
      count: 'Count',
      estimatedRange: 'Est. Range',
      // Busiest times
      busiestTimes: 'Busiest Times',
      busiestTimesCaption: 'Appointment volume by day of week and hour',
      // Top customers
      topCustomersTitle: 'Top 10 Customers',
      topCustomersCaption: 'Top customers by lifetime revenue',
      customer: 'Customer',
      revenue: 'Revenue',
      lastVisit: 'Last Visit',
      // Export
      exportCSV: 'Export CSV',
      exportPDF: 'Export PDF',
      // Vehicles
      topVehiclesTitle: 'Top Vehicles Serviced',
      topVehiclesCaption: 'Most frequently serviced vehicle makes and models',
      vehicle: 'Vehicle',
      // Revenue per hour
      revenuePerHourTitle: 'Revenue per Hour (Profitability)',
      revenuePerHourCaption: 'Service profitability ranked by revenue per hour',
      duration: 'Duration',
      revPerHour: '$/Hour',
      // Customer acquisition
      customerAcquisitionTitle: 'New vs Returning Customers',
      newCustomers: 'New',
      returningCustomers: 'Returning',
      // No-shows & visit gap
      noShows: 'No-Shows',
      avgDaysBetweenVisits: 'Avg Visit Interval',
      // Misc
      noData: 'No data available',
      actualPrices: 'Actual Prices Charged',
      priceNote: 'Optional — leave blank to use estimates in reports'
    },
    createAppointment: {
      title: 'New Appointment',
      step1: 'Customer',
      step2: 'Vehicle',
      step3: 'Services',
      step4: 'Date & Time',
      step5: 'Confirm',
      searchCustomer: 'Search for a customer',
      searchPlaceholder: 'Name, phone, or email...',
      noResults: 'No customers found',
      newCustomer: 'New Customer',
      changeCustomer: 'Change',
      firstName: 'First Name',
      lastName: 'Last Name',
      phone: 'Phone',
      email: 'Email',
      optional: 'optional',
      createCustomer: 'Create Customer',
      requiredFields: 'First name, last name, and phone are required',
      duplicatePhone: 'A customer with this phone already exists. Select them below.',
      errorCreating: 'Failed to create',
      savedVehicles: 'Saved Vehicles',
      noVehicles: 'No saved vehicles — add one below',
      addVehicle: 'Add Vehicle',
      skipVehicle: 'Skip (no vehicle)',
      servicesSelected: 'services selected',
      bookNow: 'Book for right now',
      allowPast: 'Allow past dates',
      customer: 'Customer',
      servicesLabel: 'Services',
      dateTime: 'Date & Time',
      at: 'at',
      vehicleLabel: 'Vehicle',
      adminOptions: 'Admin Options',
      status: 'Initial Status',
      sendNotification: 'Send customer notification',
      skipDeposit: 'Skip deposit requirement',
      overbook: 'Override capacity (overbook)',
      adminNotes: 'Admin Notes',
      adminNotesPlaceholder: 'Internal notes (not visible to customer)...',
      createAppointment: 'Create Appointment'
    },
    search: {
      placeholder: 'Search by name, phone, email\u2026',
      results: '{count} results',
      noResults: 'No results found',
      showing: '{from}\u2013{to} of {total}',
      prev: '\u2039 Previous',
      next: 'Next \u203A',
      rowsPerPage: 'Rows:',
      filters: 'Filters',
      clearAll: 'Clear all',
      allStatuses: 'All statuses',
      allServices: 'All services',
      vehiclePlaceholder: 'Make, model, year\u2026',
      dateFrom: 'From',
      dateTo: 'To'
    },
    recentActivity: 'Recent Activity',
    latestAppts: 'LATEST APPOINTMENTS',
    recentReviews: 'RECENT REVIEWS',
    newMessages: 'NEW MESSAGES',
    noNewMessages: 'No new messages',
    allAppointments: 'All Appointments',
    tableHeaders: {
      customer: 'Customer',
      service: 'Service',
      vehicle: 'Vehicle',
      date: 'Date',
      time: 'Time',
      status: 'Status',
      actions: 'Actions'
    },
    viewNotes: 'View Notes',
    customerReviews: 'Customer Reviews',
    total: 'total',
    avg: 'avg',
    noReviews: 'No reviews yet',
    contactMessages: 'Contact Messages',
    newBadge: 'NEW',
    markRead: 'Mark as Read',
    markResponded: 'Mark as Responded',
    reply: 'Reply',
    sendReply: 'Send Reply',
    sending: 'Sending...',
    replySuccess: 'Reply sent successfully',
    replyFailed: 'Failed to send reply',
    replyPlaceholder: 'Type your reply...',
    viewThread: 'View Thread',
    hideThread: 'Hide Thread',
    adminReply: 'Admin Reply',
    originalMessage: 'Original Message',
    noMessages: 'No messages yet',
    attachImages: 'Attach Images',
    attachHint: 'Max 3 images, 5MB each',
    allCustomers: 'All Customers',
    customerHeaders: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      appointments: 'Appointments',
      lastVisit: 'Last Visit'
    },
    na: 'N/A',
    never: 'Never',
    errorUpdate: 'Error updating appointment',
    errorMessage: 'Error updating message',
    settings: {
      title: 'Application Settings',
      googleApiKey: 'Google Places API Key',
      googlePlaceId: 'Google Place ID',
      mechanicsCount: 'Number of Mechanics',
      slotInterval: 'Slot Interval (minutes)',
      save: 'Save Settings',
      saving: 'Saving...',
      saveSuccess: 'Settings saved successfully',
      saveError: 'Failed to save settings',
      testGoogle: 'Test Google Connection',
      testing: 'Testing...',
      testSuccess: 'Google Reviews connected successfully!',
      testFail: 'Google Reviews connection failed. Check your API key and Place ID.',
      googleSection: 'Google Reviews Integration',
      schedulingSection: 'Scheduling',
      notificationSection: 'Notifications',
      twilioSection: 'SMS Provider (Twilio)',
      twilioSid: 'Account SID',
      twilioAuthToken: 'Auth Token',
      twilioFromNumber: 'From Number',
      googleHelpTitle: 'How to get Google API credentials',
      twilioHelpTitle: 'How to get Twilio credentials',
      googleHelp: '1. Go to Google Cloud Console (console.cloud.google.com)\n2. Create a project or select an existing one\n3. Enable the "Places API" under APIs & Services\n4. Go to Credentials and create an API key\n5. Find your Place ID at developers.google.com/maps/documentation/places/web-service/place-id',
      twilioHelp: '1. Sign up at twilio.com and verify your account\n2. From the Twilio Console dashboard, copy your Account SID and Auth Token\n3. Buy a phone number (or use the trial number) — this is your "From Number"\n4. Enter the credentials below and save',
      emailSection: 'Email Notifications',
      enableEmailNotifications: 'Enable email notifications to customers',
      emailFromAddress: 'From Email Address',
      emailFromHint: 'The sender email address for outgoing notifications.',
      emailProvider: 'Email Provider',
      gmailApiHint: 'Uses Google Gmail API over HTTPS. Required for Railway/cloud hosting where SMTP ports are blocked.',
      smtpHost: 'SMTP Host',
      smtpPort: 'SMTP Port',
      smtpUser: 'SMTP User',
      smtpPassword: 'SMTP Password',
      smtpHint: 'Direct SMTP connection. Works on VPS/self-hosted servers.',
      gmailClientId: 'Gmail Client ID',
      gmailClientSecret: 'Gmail Client Secret',
      gmailRefreshToken: 'Gmail Refresh Token',
      gmailTokenHint: 'Get this from Google OAuth Playground. See setup guide below.',
      gmailSetupGuide: 'Setup Guide',
      testEmail: 'Send Test Email',
      testEmailSending: 'Sending...',
      testEmailSuccess: 'Test email sent successfully!',
      testEmailFailed: 'Test email failed',
      customerSmsSection: 'Customer SMS Notifications',
      enableCustomerSms: 'Enable SMS notifications to customers',
      customerSmsHint: 'Requires Twilio credentials configured above. Only sends to customers with verified phone numbers.',
      shopInfoSection: 'Shop Information',
      shopName: 'Shop Name',
      shopAddress: 'Shop Address',
      shopPhone: 'Shop Phone',
      shopTimezone: 'Timezone',
      scheduleSection: 'Business Schedule',
      translationSection: 'Translation Provider',
      translationProvider: 'Provider',
      translationProviderNone: 'None (manual only)',
      translationProviderDeepl: 'DeepL',
      translationProviderGoogle: 'Google Translate',
      translationApiKey: 'API Key',
      translationHelp: 'Configure a translation provider to auto-translate service names and descriptions between French and English.',
      testTranslation: 'Test Translation',
      testingTranslation: 'Testing...',
      translationSuccess: '\u2713 Translation works',
      translationFailed: 'Translation failed',
      stripeSection: 'Payments (Stripe)',
      enableDeposits: 'Enable deposits',
      enableDepositsHelp: 'When enabled, customers must pay a deposit at booking time for services that require one.',
      stripeSecretKey: 'Stripe Secret Key',
      stripeWebhookSecret: 'Stripe Webhook Secret',
      stripeHelpTitle: 'How to configure Stripe?',
      stripeHelp: '1. Create a Stripe account at stripe.com\n2. In the Stripe Dashboard, go to Developers > API Keys\n3. Copy the secret key (sk_live_... or sk_test_...)\n4. Create a webhook pointing to your-domain.com/api/payments/webhook\n5. Copy the webhook signing secret (whsec_...)'
    },
    services: {
      title: 'Manage Services',
      addService: 'Add Service',
      editService: 'Edit Service',
      name: 'Service Name',
      description: 'Description',
      category: 'Category',
      duration: 'Duration (min)',
      priceMin: 'Min Price ($)',
      priceMax: 'Max Price ($)',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive',
      toggleActive: 'Toggle Active',
      confirmDelete: 'Are you sure you want to deactivate this service?',
      saveService: 'Save Service',
      saving: 'Saving...',
      saveError: 'Error saving service',
      selectCategory: 'Select a category...',
      addNewCategory: '+ Add new category',
      newCategoryPlaceholder: 'Enter new category...',
      icon: 'Icon',
      selectIcon: 'Select an icon for this service',
      nameFr: 'Service Name (FR)',
      nameEn: 'Service Name (EN)',
      descriptionFr: 'Description (FR)',
      descriptionEn: 'Description (EN)',
      categoryFr: 'Category (FR)',
      categoryEn: 'Category (EN)',
      langTabFr: 'French',
      langTabEn: 'English',
      autoTranslate: 'Auto-translate',
      translating: 'Translating...',
      translateError: 'Translation failed',
      bilingualRequired: 'Both French and English names are required'
    },
    notifications: {
      title: 'Notifications',
      markAllRead: 'Mark All Read',
      empty: 'No notifications',
      newAppointment: 'New Appointment',
      unread: 'unread',
      toastClickHint: 'Click to view appointment'
    },
    push: {
      enable: 'Enable push notifications',
      enableShort: 'Enable Push',
      active: 'Push notifications active',
      activeShort: 'Push',
      denied: 'Push notifications blocked in browser settings',
      blockedShort: 'Push blocked'
    },
    notificationSettings: {
      title: 'Notification Settings',
      enableSound: 'Enable notification sound',
      enableSms: 'Enable SMS notifications',
      adminPhone: 'Admin Phone Number',
      adminPhonePlaceholder: '+1 514-000-0000'
    },
    schedule: {
      weeklyHours: 'Weekly Hours',
      open: 'Open',
      saveHours: 'Save Hours',
      saveSuccess: 'Schedule saved successfully',
      saveError: 'Failed to save schedule',
      closures: 'Scheduled Closures',
      startDate: 'Start Date',
      endDate: 'End Date',
      reason: 'Reason',
      reasonPlaceholder: 'Holiday, vacation...',
      addClosure: 'Add'
    },
    promotions: {
      title: 'Manage Promotions',
      addPromo: 'Add Promotion',
      editPromo: 'Edit Promotion',
      titleEn: 'Title (EN)',
      titleFr: 'Title (FR)',
      bodyEn: 'Body (EN)',
      bodyFr: 'Body (FR)',
      ctaTextEn: 'Button Text (EN)',
      ctaTextFr: 'Button Text (FR)',
      ctaUrl: 'Link URL',
      placement: 'Placement',
      placements: {
        home_hero: 'Home Hero',
        home_inline: 'Home Inline',
        services_top: 'Services Top',
        booking_sidebar: 'Booking Sidebar',
        sitewide_banner: 'Sitewide Banner'
      },
      imageUrl: 'Image URL',
      bgColor: 'Background Color',
      txtColor: 'Text Color',
      priority: 'Priority',
      startAt: 'Start Date',
      endAt: 'End Date',
      active: 'Active',
      inactive: 'Inactive',
      always: 'Always',
      views: 'Views',
      clicks: 'Clicks',
      today: 'today',
      total: 'total',
      savePromo: 'Save Promotion',
      saving: 'Saving...',
      saveError: 'Error saving promotion',
      translateError: 'Translation failed',
      confirmDelete: 'Deactivate this promotion?',
      preview: 'Preview',
      learnMore: 'Learn More'
    },
    export: {
      title: 'Export Appointments',
      startDate: 'Start Date',
      endDate: 'End Date',
      status: 'Status',
      allStatuses: 'All',
      exportCsv: 'Export CSV',
      exporting: 'Exporting...'
    },
    marketing: {
      title: 'Marketing Copy',
      description: 'Edit the marketing text on customer-facing pages. Leave empty to use defaults.',
      pages: { home: 'Home', services: 'Services', about: 'About', contact: 'Contact', faq: 'FAQ', gallery: 'Gallery', book: 'Booking', login: 'Login', register: 'Register' },
      en: 'English',
      fr: 'French',
      save: 'Save Changes',
      saving: 'Saving...',
      saveSuccess: 'Marketing copy saved',
      saveError: 'Error saving',
      revert: 'Revert',
      customized: 'Customized',
      default: 'Default'
    },
    campaigns: {
      title: 'Email Campaigns',
      newCampaign: 'New Campaign',
      editCampaign: 'Edit Campaign',
      subjectEn: 'Subject (EN)',
      subjectFr: 'Subject (FR)',
      bodyEn: 'Body (EN)',
      bodyFr: 'Body (FR)',
      status: 'Status',
      draft: 'Draft',
      scheduled: 'Scheduled',
      sending: 'Sending',
      sent: 'Sent',
      failed: 'Failed',
      recipients: 'Recipients',
      sentCount: 'Sent',
      failedCount: 'Failed',
      openedCount: 'Opened',
      saveDraft: 'Save Draft',
      sendTest: 'Send Test',
      sendNow: 'Send Now',
      schedule: 'Schedule',
      confirmSend: 'Send this campaign to all subscribed customers?',
      preview: 'Preview',
      delete: 'Delete',
      confirmDelete: 'Delete this draft campaign?',
      testSent: 'Test email sent!',
      scheduledFor: 'Scheduled for',
      noRecipients: 'No eligible recipients',
      noCampaigns: 'No campaigns yet',
      recipientCount: 'Will be sent to {count} customers',
      created: 'Created',
      autoTranslate: 'Auto-translate',
      translating: 'Translating...',
      langTabEn: 'English',
      langTabFr: 'French',
      viewDetails: 'View Details',
      backToList: 'Back to Campaigns',
      paused: 'Paused',
      resume: 'Resume',
      quotaInfo: 'Daily quota: {sent}/{limit} sent ({remaining} remaining)'
    },
    depositAmount: 'Deposit Amount ($)',
    depositAmountHelp: 'Leave empty for no deposit required',
    paymentStatus: 'Payment',
    paymentPaid: 'Paid',
    paymentPending: 'Pending',
    paymentRefunded: 'Refunded',
    paymentNone: 'None',
    import: {
      title: 'Import Customers',
      description: 'Upload a QuickBooks CSV export to import customers. Expected columns: First Name, Last Name, Email, Phone.',
      preview: 'Preview Import',
      toImport: 'To Import',
      toSkip: 'Already Exist',
      errorsCount: 'Errors',
      csvErrors: 'CSV Errors',
      confirmImport: 'Confirm Import',
      imported: 'Imported',
      skipped: 'Skipped',
      sendOnboarding: 'Send Onboarding Emails',
      onboardingHint: 'Send password setup emails to {count} imported customers',
      importAnother: 'Import Another File',
      name: 'Name',
      phone: 'Phone'
    },
    customerProfile: {
      identity: 'Identity',
      appointmentsSection: 'Appointments',
      vehiclesSection: 'Vehicles',
      reviewsSection: 'Reviews',
      messagesSection: 'Messages',
      remindersSection: 'Reminders',
      contactInfo: 'Contact Info',
      language: 'Language',
      lastLogin: 'Last Login',
      notifications: 'Notification Preferences',
      emailNotif: 'Email',
      marketing: 'Marketing',
      verified: 'Verified',
      notVerified: 'Not verified',
      customerSince: 'Customer since',
      imported: 'Imported',
      totalAppts: 'Total Appts',
      upcoming: 'Upcoming',
      reviewCount: 'Reviews',
      vehicleCount: 'Vehicles',
      lastAppt: 'Last Completed Appointment',
      noAppointments: 'No appointments',
      noVehicles: 'No vehicles',
      noReminders: 'No reminders',
      plate: 'Plate',
      color: 'Color',
      replies: 'replies',
      reminderDate: 'Reminder Date',
      channels: 'Channels',
      phone2: 'Secondary Phone',
      mergeWith: 'Merge with\u2026',
      editButton: 'Edit',
      deleteButton: 'Delete',
      saveChanges: 'Save Changes',
      firstName: 'First Name',
      lastName: 'Last Name',
      readOnly: 'read-only',
      addVehicle: 'Add Vehicle',
      editVehicle: 'Edit Vehicle',
      deleteVehicleConfirm: 'Delete this vehicle? This cannot be undone.',
      vehicleRequired: 'Make, model, and year are required',
      vehicleVin: 'VIN',
      vehicleColor: 'Color'
    },
    merge: {
      mergeButton: 'Merge Selected Customers',
      title: 'Merge Customer Accounts',
      selectPrimary: 'Select which account to keep. All data from the other account will be transferred.',
      primary: 'Primary \u2014 keeps identity',
      secondary: 'Secondary \u2014 will be deactivated',
      warning: 'This action cannot be undone. The secondary account will be permanently deactivated.',
      confirmWarning: 'This action cannot be undone. Are you sure?',
      confirm: 'Confirm Merge',
      cancel: 'Cancel',
      success: 'Accounts merged successfully!',
      created: 'Created',
      appointments: 'appointments',
      vehicles: 'vehicles',
      reviews: 'reviews',
      messages: 'messages',
      reminders: 'reminders',
      consents: 'consents',
      selectTwo: 'Select exactly 2 customers to merge',
      searchPlaceholder: 'Search customer to merge with\u2026'
    },
    reminders: {
      title: 'Maintenance Reminders',
      allReminders: 'All Reminders',
      serviceRules: 'Service Rules',
      customer: 'Customer',
      service: 'Service',
      reminderDate: 'Reminder Date',
      channels: 'Channels',
      status: 'Status',
      actions: 'Actions',
      scheduled: 'Scheduled',
      sent: 'Sent',
      failed: 'Failed',
      cancelled: 'Cancelled',
      allStatuses: 'All statuses',
      noReminders: 'No reminders scheduled',
      reschedule: 'Reschedule',
      cancel: 'Cancel',
      confirmCancel: 'Cancel this reminder?',
      cancelError: 'Failed to cancel reminder',
      rescheduleError: 'Failed to reschedule',
      newDate: 'New date',
      saveReschedule: 'Save',
      scheduleTitle: 'Complete Appointment',
      scheduleReminder: 'Schedule a maintenance reminder',
      interval: 'Remind in',
      months: 'months',
      customDate: 'Custom date',
      willSend: 'Reminder will be sent on',
      skipReminder: 'Complete without reminder',
      completeAndSchedule: 'Complete & Schedule',
      completeOnly: 'Complete',
      enabled: 'Enabled',
      disabled: 'Disabled',
      edit: 'Edit',
      intervals: 'Intervals',
      saveRule: 'Save Rule',
      saveRuleError: 'Failed to save rule',
      rulesDescription: 'Configure default reminder intervals for each service. These defaults are suggested when completing appointments.',
      noRules: 'No rules configured.'
    }
  },

  forgotPassword: {
    title: 'Reset Password',
    subtitle: 'Enter your email to receive a reset link',
    emailLabel: 'Email Address',
    button: 'Send Reset Link',
    sending: 'Sending...',
    backToLogin: '\u2190 Back to Sign In',
    successTitle: 'Check Your Email',
    successMessage: 'If an account exists with that email, we sent a password reset link. Please check your inbox (and spam folder).',
    error: 'Something went wrong. Please try again.',
    verifyFirst: 'Verify Your Email First',
    verifyMessage: 'Your account email is not yet verified. We sent a new verification code to your email. Please log in and verify your email before resetting your password.'
  },

  setPassword: {
    title: 'Set Your Password',
    welcome: 'Welcome, {name}! Create a password to access your account.',
    passwordLabel: 'Password',
    confirmLabel: 'Confirm Password',
    marketingLabel: 'I agree to receive offers, promotions, and tips by email from Mécanique Auto CJPA. I can unsubscribe at any time.',
    submit: 'Set Password & Sign In',
    setting: 'Setting Password...',
    invalidTitle: 'Invalid Link',
    invalidLink: 'Invalid or missing link parameters.',
    expired: 'This link has expired or is invalid.',
    tooShort: 'Password must be at least 6 characters.',
    mismatch: 'Passwords do not match.',
    error: 'Failed to set password. The link may have expired.'
  },

  emailVerify: {
    title: 'Verify Your Email',
    subtitle: 'We sent a 6-digit code to',
    enterCode: 'Verification Code',
    verify: 'Verify',
    verifying: 'Verifying...',
    resend: 'Resend Code',
    cooldown: 'Resend in {seconds}s',
    success: 'Email verified successfully!',
    verifyError: 'Verification failed',
    sendError: 'Failed to send verification code',
    checkSpam: 'Check your spam folder if you don\'t see the email.',
    signOut: 'Sign out'
  },

  phoneVerify: {
    title: 'Verify Phone Number',
    enterPhone: 'Enter your phone number to receive a verification code via SMS.',
    phoneLabel: 'Phone Number',
    sendCode: 'Send Code',
    sending: 'Sending...',
    sendError: 'Failed to send verification code',
    enterCode: 'Enter the 6-digit code sent to',
    codeLabel: 'Verification Code',
    verify: 'Verify',
    verifying: 'Verifying...',
    verifyError: 'Verification failed',
    success: 'Phone verified successfully!'
  },

  seo: {
    _locale: 'en_CA',
    home: {
      title: 'Mécanique Auto CJPA | Auto Repair Shop Montréal-Nord | 514-327-2107',
      description: 'Trusted auto repair shop in Montréal-Nord. Oil changes, brakes, engine diagnostics, transmission and more. ASE-certified technicians. Call 514-327-2107.',
      path: '/en',
      routeName: 'home'
    },
    services: {
      title: 'Automotive Services | Mécanique Auto CJPA Montréal-Nord',
      description: 'Explore our services: oil changes, brakes, engine diagnostics, transmission, wheel alignment. Transparent pricing and certified technicians in Montréal-Nord.',
      path: '/en/services',
      routeName: 'services'
    },
    about: {
      title: 'About Us | Mécanique Auto CJPA Montréal-Nord',
      description: 'Founded in 2016 in Montréal-Nord, Mécanique Auto CJPA delivers quality automotive service with integrity and expertise. Discover our story and values.',
      path: '/en/about',
      routeName: 'about'
    },
    contact: {
      title: 'Contact Us | Mécanique Auto CJPA Montréal-Nord',
      description: 'Contact Mécanique Auto CJPA at 514-327-2107 or visit us at 10011 Av. de Rome, Montréal-Nord. Open Mon-Fri 9AM-6PM.',
      path: '/en/contact',
      routeName: 'contact'
    },
    faq: {
      title: 'FAQ | Mécanique Auto CJPA Montréal-Nord',
      description: 'Answers to frequently asked questions about our auto services, booking, pricing and warranties. Mécanique Auto CJPA, Montréal-Nord.',
      path: '/en/faq',
      routeName: 'faq'
    },
    gallery: {
      title: 'Gallery | Mécanique Auto CJPA Montréal-Nord',
      description: 'Photo gallery of our automotive repair and maintenance work. Mécanique Auto CJPA, Montréal-Nord.',
      path: '/en/gallery',
      routeName: 'gallery'
    },
    privacy: {
      title: 'Privacy Policy | Mécanique Auto CJPA',
      description: 'Mécanique Auto CJPA privacy policy. Compliant with Quebec Law 25 and PIPEDA.',
      path: '/en/privacy',
      routeName: 'privacy'
    },
    terms: {
      title: 'Terms of Service | Mécanique Auto CJPA',
      description: 'Mécanique Auto CJPA terms of service. Warranties, pricing and consumer rights under Quebec law.',
      path: '/en/terms',
      routeName: 'terms'
    },
    book: {
      title: 'Book an Appointment | Mécanique Auto CJPA Montréal-Nord',
      description: 'Book your appointment online at Mécanique Auto CJPA. Choose your service, date and time. Montréal-Nord.',
      path: '/en/book',
      routeName: 'book'
    },
    login: {
      title: 'Sign In | Mécanique Auto CJPA',
      description: 'Sign in to your Mécanique Auto CJPA account.',
      path: '/en/login',
      routeName: 'login',
      noindex: true
    },
    register: {
      title: 'Create Account | Mécanique Auto CJPA',
      description: 'Create your Mécanique Auto CJPA account to book appointments.',
      path: '/en/register',
      routeName: 'register',
      noindex: true
    },
    dashboard: {
      title: 'My Account | Mécanique Auto CJPA',
      description: 'Manage your appointments and account at Mécanique Auto CJPA.',
      path: '/en/dashboard',
      routeName: 'dashboard',
      noindex: true
    },
    admin: {
      title: 'Admin Dashboard | Mécanique Auto CJPA',
      description: 'Mécanique Auto CJPA admin dashboard.',
      path: '/en/admin',
      routeName: 'admin',
      noindex: true
    }
  },

  images: {
    hero: 'Mécanique Auto CJPA garage interior — professional auto repair shop in Montréal-Nord',
    aboutShop: 'Inside the Mécanique Auto CJPA workshop — clean, well-equipped automotive repair facility in Montréal-Nord',
    aboutTeam: 'CJPA certified mechanics working on a vehicle engine in Montréal-Nord',
    servicesHeader: 'Professional mechanic performing vehicle diagnostic scan at Mécanique Auto CJPA',
    gallery1: 'Engine repair and diagnostic work at Mécanique Auto CJPA',
    gallery2: 'Professional brake rotor and pad replacement service',
    gallery3: 'Oil change service — draining old motor oil',
    gallery4: 'OBD-II scanner diagnostic on vehicle computer system',
    gallery5: 'Transmission gearbox repair and maintenance',
    gallery6: 'Precision laser wheel alignment service',
  },

  common: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    or: 'or'
  }
};
